Vue.component('callback-modal', {
    methods: {
        close() {
            this.opened = false
        },
        open() {
            this.opened = true
        },
    },
});